"use strict";

var _sdkCore = require("../sdk-core");
var _BrowserConsole = _interopRequireDefault(require("./BrowserConsole"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
_sdkCore.logger.add(new _BrowserConsole.default({
  level: 'debug'
}));